module.exports = __webpack_public_path__ + "img/3.43933e09.jpg";